import React, { useState, useRef, useEffect } from "react"
import styled from "styled-components"
import { gsap } from "gsap"

import Link from "@atoms/link"
import { Column } from "@atoms/layout"
import { media } from "@styles/breakpoints"

const BlogCategories = () => {
  const catList = useRef()
  const catIcon = useRef()
  const [dropdown, setDropdown] = useState(false)
  const [tl] = useState(gsap.timeline({ paused: true }))

  const toggleDropdown = () => {
    if (window.innerWidth < 1200) {
      setDropdown(!dropdown)
    }
  }

  useEffect(() => {
    tl.addLabel("start")
    tl.set(
      ".searchInput",
      {
        padding: "0",
        duration: 0,
      },
      "start"
    )
    tl.set(
      ".blogSearch",
      {
        zIndex: "-2",
        opacity: "0",
        padding: "0",
        duration: 0,
      },
      "start"
    )
    tl.to(
      ".blogSearch",
      {
        flex: "0 0 0%",
      },
      "start"
    )
    tl.to(
      catList.current,
      {
        backgroundColor: "white",
        borderColor: "var(--gray--20)",
        flex: "0 0 100%",
        duration: 1,
      },
      "start"
    )
    tl.addLabel("open")
    tl.to(
      catIcon.current,
      {
        rotate: "0",
      },
      "open"
    )
    tl.to(
      catList.current,
      {
        maxHeight: "12rem",
      },
      "open"
    ).reverse()
  }, [tl])

  useEffect(() => {
    tl.reversed(!dropdown)
  }, [tl, dropdown])

  return (
    <Categories className="blogCategories">
      <List ref={catList} onClick={toggleDropdown}>
        <Category>
          <Link to="/blog" activeClassName="-active" sm strong>
            Latest
          </Link>
          <IconCategories
            ref={catIcon}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 12 12"
          >
            <path d="M.004 7.875l1.5 1.5 4.5-4.5 4.5 4.5 1.5-1.5-6-6-6 6z"></path>
          </IconCategories>
        </Category>
        <Category>
          <Link to="/customers" activeClassName="-active" sm strong>
            Customers
          </Link>
        </Category>
        <Category>
          <Link to="/product" activeClassName="-active" sm strong>
            Product
          </Link>
        </Category>
        <Category>
          <Link to="/business" activeClassName="-active" sm strong>
            Business
          </Link>
        </Category>
      </List>
    </Categories>
  )
}

export default BlogCategories

const Categories = styled(Column)`
  flex: 1 1 50%;
  transition: var(--transitionBase);
  margin: 0;
`

const List = styled.ul`
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  margin: 1rem 0;
  max-height: 3rem;
  overflow: hidden;
  padding: 0 0.5rem;
  transition: var(--transitionBase);

  ${media.sm`
    margin: 1.5rem 0;
    padding: 0;
    flex-direction: row;
  `}
`

const Category = styled.li`
  display: block;
  border-bottom: 1px solid var(--gray--20);
  padding: 0.675rem 0;

  ${media.sm`
    border: 0;
    padding: 0 0.5rem;
    
    &:first-of-type {
      padding-left: 0;
    }
  `}


  &:last-of-type {
    border: 0;
  }

  a.-active {
    color: var(--colorPrimary);
  }
`

const IconCategories = styled.svg`
  height: 14px;
  right: 1.5rem;
  position: absolute;
  top: 2rem;
  transform: rotate(180deg);
  transition: var(--transitionBase);
  width: 14px;

  ${media.sm`
    display: none;
  `}

  path {
    fill: var(--gray--80);
  }
`
